import { render, staticRenderFns } from "./OlympicAthletes.vue?vue&type=template&id=4fbab05a&scoped=true"
import script from "./OlympicAthletes.vue?vue&type=script&lang=js"
export * from "./OlympicAthletes.vue?vue&type=script&lang=js"
import style0 from "./OlympicAthletes.vue?vue&type=style&index=0&id=4fbab05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbab05a",
  null
  
)

export default component.exports